import { createContext } from 'react';

const NotificationContext = createContext({
    notifications: [],
    info: () => {},
    success: () => {},
    warning: () => {},
    error: () => {},
    closeNotification: () => {},
    clearAll: () => {}
});

export default NotificationContext;